<template>
  <div data-test="hide-cases-from-web-panel" class="card">
    <div class="card-header">{{ label }}</div>
    <div class="card-body">
      <div class="card-text">
        <p>
          <small>{{ trans("feature.hideCasesFromWebDescription") }}</small>
        </p>
        <p v-if="!canManage">
          <small data-test="hide-cases-from-web-super-only">{{
            trans("feature.hideCasesFromWebSuperOnly")
          }}</small>
        </p>

        <div
          v-for="product in activeProducts"
          :key="product.id"
          class="mb-2"
          :data-test="`hide-cases-from-web-toggle-${product.id}`"
        >
          <DerToggleWithLabel
            :model-value="isEnabled(product.id)"
            :disabled="!canManage"
            :label="product.display_name"
            @update:model-value="toggle(product.id, $event)"
          />
        </div>

        <p v-if="activeProducts.length === 0">
          <small>{{ trans("feature.hideCasesFromWebNoProducts") }}</small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import DerToggleWithLabel from "../../design-system/DerToggleWithLabel.vue";

export default {
  components: { DerToggleWithLabel },
  props: {
    features: {},
    featureId: {},
    region: {},
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    canManage() {
      return this.$can("manage_super_settings");
    },
    activeProducts() {
      return Object.values(this.region?.all_products ?? {}).filter(
        (product) => product.active,
      );
    },
    enabledProducts() {
      return this.features[this.featureId].config?.products ?? {};
    },
  },
  methods: {
    isEnabled(productId) {
      return productId in this.enabledProducts;
    },
    toggle(productId, on) {
      if (!this.canManage) {
        return;
      }

      this.$vueAlert
        .confirm(
          this.trans(
            on
              ? "feature.hideCasesFromWebConfirm"
              : "feature.hideCasesFromWebDisableConfirm",
          ),
          undefined,
          undefined,
          {
            confirmButtonText: this.trans("general.modalConfirmButton"),
            cancelButtonText: this.trans("general.modalCancelButton"),
          },
        )
        .then(() => this.apply(productId, on))
        .catch(() => {});
    },
    apply(productId, on) {
      const config = JSON.parse(
        JSON.stringify(this.features[this.featureId].config ?? {}),
      );
      config.products = config.products ?? {};

      if (on) {
        // The audit marker (enabled_at/enabled_by) is stamped server-side.
        config.products[productId] = {};
      } else {
        delete config.products[productId];
      }

      this.features[this.featureId].config = config;
      this.features[this.featureId].active =
        Object.keys(config.products).length > 0;
    },
  },
};
</script>
